module.exports = __webpack_public_path__ + "static/img/logo.3e6b7c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 10